import axios from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/apiEndpoints';

export const Focus360Payload = {
  chat_id: '',
  query: '',
  customer_id: '',
  location: '',
  site_id: [],
  is_new_session: false,
  application_id: '',
  user_id: '',
};

// New API functions for customers, locations, and sites
export const fetchCustomers = async (searchQuery = '', page = 1, pageSize = 20) => {
  const params = {
    search: searchQuery,
    page,
    page_size: pageSize,
  };
  
  const response = await axios.get('/apiv2/api/customers', { params });
  return response.data;
};

export const fetchLocations = async (groupKey) => {
  const params = {
    group_key: groupKey,
  };
  
  const response = await axios.get('/apiv2/api/locations', { params });
  return response.data;
};

export const fetchSites = async (groupKey, countryKey) => {
  const params = {
    group_key: groupKey,
    country: countryKey,
  };
  
  const response = await axios.get('/apiv2/api/sites', { params });
  return response.data;
};

export const fetchFocusInsights = async (payload) => {
  const response = await axios.post(API_ENDPOINTS.insights, payload);
  return response.data;
};

export const Focus360StreamCallbacks = {
  onChunk: (partialContent) => {},
  onHeaderCreated: (header, conversationId) => {},
  onStreamComplete: (conversationId, pairId) => {},
}

export const streamFocus360Query = async (
  payload,
  callbacks
) => {
  try {
    if (payload.is_new_session) {
      // For new sessions, get JSON response and pass it through onChunk
      const response = await axios.post(API_ENDPOINTS.insights, payload);
      // Convert JSON response to string and send via onChunk
      callbacks.onChunk(JSON.stringify(response.data.data || response.data, null, 2));
      // Call onStreamComplete for consistency
      callbacks.onStreamComplete?.(payload.chat_id);
    } else {
      // For existing sessions, handle actual streaming
      await streamFocus360Insights(payload, callbacks);
    }
  } catch (error) {
    console.error('Focus360 query failed:', error);
    throw error;
  }
};

export async function streamFocus360Insights(
  payload,
  callbacks
) {
  // For streaming, we still need to use fetch as axios doesn't handle SSE streams well
  const accessToken = localStorage.getItem('access_token');
  
  const response = await fetch(API_ENDPOINTS.insights, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken && { 'Authorization': `Bearer ${accessToken}` }),
    },
    body: JSON.stringify(payload),
  });

  if (!response.body) {
    throw new Error('Streaming not supported');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    const lines = buffer.split('\n');
    buffer = lines.pop() || ''; // carry over partial line

    for (const line of lines) {
      if (line.startsWith('data:')) {
        try {
          const jsonStr = line.replace(/^data:\s*/, '');
          const parsed = JSON.parse(jsonStr);

          if (parsed.text) {
            callbacks.onChunk(parsed.text);
          } else if (parsed.type === 'header_created' && parsed.header) {
            callbacks.onHeaderCreated?.(parsed.header, parsed.conversation_id);
          } else if (parsed.type === 'stream_complete') {
            callbacks.onStreamComplete?.(parsed.conversation_id, parsed.pair_id);
          }
        } catch (e) {
          console.error('Failed to parse SSE JSON line:', line, e);
        }
      }
    }
  }
}
